import React from "react"
import styled from "styled-components"

export default function Dots({
  activated,
  background,
  inactiveBackground,
  shadow,
}: any) {
  const dotsData = [
    { active: activated > 2, background, inactiveBackground, shadow },
    { active: activated > 1, background, inactiveBackground, shadow },
    { active: activated > 0, background, inactiveBackground, shadow },
  ]
  return (
    <Container>
      {dotsData.map((dot, index) => (
        <Dot
          key={index}
          active={dot.active}
          background={dot.background}
          inactiveBackground={dot.inactiveBackground}
          shadow={dot.shadow}
        />
      ))}
    </Container>
  )
}

export const Container = styled.div`
  margin-right: -2px;
  position: absolute;
  right: 0px;
  z-index: 1;
  @media only screen and (min-width: 768px) {
    right: -1px;
  }
`

export const Dot = styled.div<{
  active: boolean
  background: string
  inactiveBackground: string
  shadow: string
}>`
  width: 4px;
  height: 4px;
  margin-top: 2px;
  margin-bottom: 3px;
  border-radius: 4px;
  z-index: 1;
  ${({ active, background, inactiveBackground, shadow }) =>
    active
      ? `background: linear-gradient( ${background} );`
      : `background: ${inactiveBackground};  box-shadow:${shadow};`}

  @media only screen and (min-width: 768px) {
    width: 6px;
    height: 6px;
    margin-top: 4px;
    margin-bottom: 5px;
  }
`
